import {
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_FAILED,
    GET_PRODUCTS_LOADING,
    GET_SINGLE_PRODUCT_LOADING,
} from '../constants'
import axios from 'axios'


export function maybeGetSingleProduct(productId) {
    return (dispatch, getState) => {
        const { products } = getState();
        let activeProduct = products.reduce((t, c) => c.id == productId ? c : t, null);
        if (activeProduct) {
            console.log("Found the current active product in our cached product list: ", activeProduct);
        } else {
            console.log(`Did not find the active product in our cached product list, requesting productId: ${productId}`)
            dispatch({ type: GET_SINGLE_PRODUCT_LOADING })
        }
    }
}

export function getProducts() {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(getProductsLoading(true))
            axios.get(`${process.env.BASE_URL}/products?orgId=2`).then((response) => {
                dispatch(getProductsSuccess(response))
                resolve(response)
            }).catch(err => dispatch(getProductsFailed(err)))
        })
    }
}

export const getProductsLoading = (bool) => ({ type: GET_PRODUCTS_LOADING, bool })
export const getProductsSuccess = (result) => ({ type: GET_PRODUCTS_SUCCESS, result })
export const getProductsFailed = (msg) => ({ type: GET_PRODUCTS_FAILED, msg })